export default __webpack_public_path__ + "static/media/sugarcrm-negative.41f783d7.svg";